import { createSelector } from '@reduxjs/toolkit';
export const clientSettingsSelector = ({
  clientSettings
}) => clientSettings;
export const clientResetSelector = createSelector(clientSettingsSelector, ({
  clientReset
}) => clientReset);
export const hideSubmitButtonSelector = createSelector(clientSettingsSelector, ({
  hideSubmitButton
}) => hideSubmitButton);
export const submitInProgressSelector = createSelector(clientSettingsSelector, ({
  submitInProgress
}) => submitInProgress);
export const submissionSuccessfulSelector = createSelector(clientSettingsSelector, ({
  submissionSuccessful
}) => submissionSuccessful);
export const addNewLoopEntrySelector = createSelector(clientSettingsSelector, ({
  activeRowGuid
}) => activeRowGuid);
export const unsupportedFieldSelector = createSelector(clientSettingsSelector, ({
  unsupportedField
}) => unsupportedField);
export const showingUnsupportedFieldSelector = createSelector(clientSettingsSelector, ({
  showingUnsupportedField
}) => showingUnsupportedField);
export const interactiveClientSelector = createSelector(clientSettingsSelector, ({
  interactiveClient
}) => interactiveClient);
export const clientTypeSelector = createSelector(clientSettingsSelector, ({
  clientType
}) => clientType);
export const formModeSelector = createSelector(clientSettingsSelector, ({
  formMode
}) => formMode || 'edit');
export const undoableSelector = createSelector(clientSettingsSelector, ({
  undoEnabled
}) => undoEnabled);

//* brought in to access supported fields from dispatchClient reducer
export const supportedFieldsSelector = createSelector(clientSettingsSelector, ({
  supportedFields
}) => supportedFields);
export const unsupportedMessageSelector = createSelector(clientSettingsSelector, ({
  unsupportedMessage
}) => unsupportedMessage);
export const disableRequiredSelector = createSelector(clientSettingsSelector, ({
  disableRequired
}) => disableRequired);
export const ignoreConditionsSelector = createSelector(clientSettingsSelector, ({
  ignoreConditions
}) => ignoreConditions);
export const allowLoopEditsSelector = createSelector(clientSettingsSelector, ({
  allowLoopEdits
}) => allowLoopEdits);
export const disableReadOnlyFieldsSelector = createSelector(clientSettingsSelector, ({
  disableReadOnlyFields
}) => disableReadOnlyFields);
export const referenceDataEndpointSelector = createSelector(clientSettingsSelector, ({
  referenceDataEndpoint
}) => referenceDataEndpoint);